module.exports = __webpack_public_path__ + "img/icon_rshb.cb65cefb.svg";